import { Select, type ComboboxItem } from "@mantine/core";
import { useProperty } from "@/hooks/useProperty";
import { useUiStore } from "@/stores/ui";

export function PropertySwitcher() {
  const { propertyId, properties } = useProperty();
  const setCurrentPropertyId = useUiStore((s) => s.setCurrentPropertyId);

  if (properties.length < 2) return null;

  const options: ComboboxItem[] = properties.map((p) => ({
    value: p.id,
    label: p.domain ? `${p.name} (${p.domain})` : p.name,
  }));

  return (
    <Select
      data={options}
      value={propertyId}
      onChange={(val) => setCurrentPropertyId(val)}
      placeholder="Select property"
      size="sm"
      variant="filled"
      allowDeselect={false}
      styles={{
        root: { minWidth: 180 },
      }}
    />
  );
}
